import type { ISupervisionGetOne } from '../../interfaces/supervisionGetOne';
import type { ITask } from '../../interfaces/task';
import { TaskType } from '../../../../common/enums/task';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { Button } from '../common';

export function TakeSupervisionButton(props: {
    practitionerId?: string;
    reloadProcess?: () => Promise<void>;
    supervision?: ISupervisionGetOne;
    task?: ITask;
}) {
    if (
        !props.task ||
        props.task.performerPractitionerId === props.practitionerId ||
        props.task.type !== TaskType.supervise ||
        !props.reloadProcess
    ) {
        return null;
    }

    return (
        <Button
            color="secondary"
            large
            onClick={async () => {
                await takeSupervision(props);
            }}
            outlined
        >
            {translateKey('supervision.takeOver')}
        </Button>
    );
}

async function takeSupervision(props: {
    practitionerId?: string;
    reloadProcess?: () => Promise<void>;
    supervision?: ISupervisionGetOne;
    task?: ITask;
}) {
    if (props.supervision && props.supervision.id) {
        const url = `/api/supervisions/${props.supervision.id}/takeSupervision`;
        await fetchJson(url, 'POST');
        await props.reloadProcess!();
    } else if (props.task) {
        const url = `/api/tasks/${props.task.id}/takeTask`;
        await fetchJson(url, 'POST');
        await props.reloadProcess!();
    }
}
